import { render, staticRenderFns } from "./IntegrationGameActiveBadge.vue?vue&type=template&id=647e707c&scoped=true&"
import script from "./IntegrationGameActiveBadge.vue?vue&type=script&lang=js&"
export * from "./IntegrationGameActiveBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e707c",
  null
  
)

export default component.exports